import React from 'react';

const StarIcon = ({
  color = '#978CF9',
  size = 14
}: {
  color?: string;
  size?: number;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.30579 8.29201L2.48039 6.4309C2.34511 6.29297 2.29772 6.09128 2.35742 5.90754C2.41712 5.72379 2.57401 5.58847 2.76453 5.5564L5.2176 5.14343L6.53903 2.61142C6.62841 2.44015 6.80558 2.33276 6.99877 2.33276C7.19196 2.33276 7.36913 2.44015 7.45851 2.61142L8.77984 5.14343L11.2329 5.5564C11.4234 5.58847 11.5803 5.72379 11.64 5.90753C11.6997 6.09127 11.6523 6.29297 11.517 6.4309L9.69165 8.29201M4.3057 8.29256L3.89312 11.0716C3.86476 11.2627 3.94498 11.4538 4.10128 11.5673C4.25758 11.6809 4.46405 11.6981 4.63703 11.6121L6.99869 10.4375L9.36035 11.6121C9.53333 11.6981 9.7398 11.6809 9.8961 11.5673C10.0524 11.4538 10.1326 11.2627 10.1043 11.0716L9.69168 8.29256"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default StarIcon;
